export default __webpack_public_path__ + "static/media/dp-api-crushes.7075eb22.png";